import apiManager from '@/api';

const module = {
  namespaced: true,
  state: () => ({
    fleetSizes: [],
  }),
  mutations: {
    setFleetSizes(state, fleetSizes) {
      state.fleetSizes = fleetSizes;
    },
  },
  actions: {
    async loadFleetSizes({ commit }) {
      const sizes = await apiManager.fleetSize.getAll();
      commit('setFleetSizes', sizes.map((s) => ({ value: s.id, text: s.name })));
    },
  },
};

export default module;
